import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '../components/modal'
import Ajax from '../components/ajax'
import { useForm } from 'react-hook-form'
import Loading from '../components/loading'
import { userLogin } from '../store/slices/mainSlices'
import { useDispatch } from 'react-redux'

export default function AdditionalData() {
  //Translate initialization
  const { t } = useTranslation()
  document.title = 'Additional Data | ' + t('name')

  //State manager initialization
  const dispatch = useDispatch()
  const [modalAdd, setModalAdd] = useState(false)
  const [modalTitle, setModalTitle] = useState(false)
  const [exemptions, setExemptions] = useState(false)
  const [exemptionsStatus, setExemptionsStatus] = useState(false)
  const [statuses, setStatuses] = useState(false)
  const [statusesPlacement, setStatusesPlacement] = useState(false)
  const [positions, setPositions] = useState(false)
  const [employerStatus, setEmployerStatus] = useState(false)
  const [objects, setObjects] = useState(false)
  const [exerciseType, setExerciseType] = useState(false)
  const [modalButton, setModalButton] = useState('')
  const [descriptionModal, setDescriptionModal] = useState(false)

  //Modal for edit
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      additionalData: {
        code: '',
        name: '',
        description: '',
      },
    },
    reValidateMode: 'onChange',
  })

  //Modal for exemptions
  const addExemptions = useCallback(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/exemptions/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        setExemptions(data.data)
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  //Modal for exemptions status
  const addExemptionsStatus = useCallback(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/exemption-statuses/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        setExemptionsStatus(data.data)
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  //Modal for statuses
  const addStatuses = useCallback(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/statuses/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        setStatuses(data.data)
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  //Modal for status of placement
  const addStatusesPlacement = useCallback(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/placements-statuses/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        setStatusesPlacement(data.data)
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  //Modal for positions
  const addPositions = useCallback(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/positions/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        setPositions(data.data)
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  //Modal for employer status
  const addEmployerStatus = useCallback(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/employer-statuses/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        setEmployerStatus(data.data)
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  //Modal for objects
  const addObjects = useCallback(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/items/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        setObjects(data.data)
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  //Modal for exercise type
  const addExerciseType = useCallback(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/task-types/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        setExerciseType(data.data)
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  //Request for all Employers
  useEffect(() => {
    addExemptions()
    addExemptionsStatus()
    addStatuses()
    addStatusesPlacement()
    addPositions()
    addEmployerStatus()
    addObjects()
    addExerciseType()
  }, [addExemptions, addExemptionsStatus, addStatuses, addStatusesPlacement, addPositions, addEmployerStatus, addObjects, addExerciseType])

  //Function for delete additional
  const deleteAdditional = useCallback(
    event => {
      const currentUrl = event.target.dataset.value
      const ajaxUrl = 'manager/' + currentUrl + '/delete'
      const ajaxBody = {
        id: event.target.dataset.id,
      }
      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          if (currentUrl === 'exemptions') {
            addExemptions()
          }
          if (currentUrl === 'statuses') {
            addStatuses()
          }
          if (currentUrl === 'positions') {
            addPositions()
          }
          if (currentUrl === 'employer-statuses') {
            addEmployerStatus()
          }
          if (currentUrl === 'task-types') {
            addExerciseType()
          }
          if (currentUrl === 'exemption-statuses') {
            addExemptionsStatus()
          }
          if (currentUrl === 'items') {
            addObjects()
          }
          if (currentUrl === 'placements-statuses') {
            addStatusesPlacement()
          }
          setModalAdd(false)
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    },
    [addExemptions, addEmployerStatus, addExemptionsStatus, addExerciseType, addObjects, addPositions, addStatuses, addStatusesPlacement, dispatch]
  )

  //Function for open modal
  const openModal = useCallback(
    event => {
      setModalTitle(event.target.closest('.table').querySelector('h3').textContent)
      if (event.target.closest('.table').dataset.value === 'exemptions') {
        setDescriptionModal(true)
      }
      if (event.target.closest('.table').dataset.value === 'exemption-statuses') {
        setDescriptionModal(false)
      }
      if (event.target.closest('.table').dataset.value === 'statuses') {
        setDescriptionModal(true)
      }
      if (event.target.closest('.table').dataset.value === 'placements-statuses') {
        setDescriptionModal(true)
      }
      if (event.target.closest('.table').dataset.value === 'positions') {
        setDescriptionModal(true)
      }
      if (event.target.closest('.table').dataset.value === 'employer-statuses') {
        setDescriptionModal(false)
      }
      if (event.target.closest('.table').dataset.value === 'items') {
        setDescriptionModal(true)
      }
      if (event.target.closest('.table').dataset.value === 'task-types') {
        setDescriptionModal(false)
      }
      if (event.target.value === 'add') {
        document.querySelector('.sendButton').setAttribute('data-value', 'add')
        const currentUrl = event.target.closest('.table').dataset.value
        document.querySelector('.sendButton').setAttribute('data-url', currentUrl)
        reset()
        setModalAdd(true)
        setModalButton(
          <span className='sendButton' onClick={() => setModalAdd(false)}>
            Cancel
          </span>
        )
      } else {
        document.querySelector('.sendButton').setAttribute('data-value', 'edit')
        const currentUrl = event.target.closest('.item').dataset.value
        document.querySelector('.sendButton').setAttribute('data-url', currentUrl)
        document.querySelector('.sendButton').setAttribute('data-id', event.target.closest('.item').dataset.id)
        const ajaxBody = { id: event.target.closest('.item').dataset.id }
        const method = 'post'
        const ajaxUrl = 'manager/' + currentUrl + '/getOne'

        const promise = new Promise((resolve, reject) => {
          Ajax(ajaxBody, ajaxUrl, resolve, method)
        })

        promise.then(data => {
          const dataResponse = data.responseCode.responseCode
          if (dataResponse === '1') {
            setValue(
              'additionalData',
              {
                code: data.data.code,
                name: data.data.name,
                description: data.data.description,
              },
              { shouldValidate: true }
            )
            setModalButton(
              <span className='sendButton deleteButton' data-id={data.data.id} data-value={currentUrl} onClick={event => deleteAdditional(event)}>
                Delete
              </span>
            )
            setModalAdd(true)
          } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
            dispatch(userLogin(false))
            localStorage.removeItem('userToken')
            localStorage.removeItem('userLogin')
          } else {
            console.log(data.responseCode.responseCode)
          }
        })
      }
    },
    [reset, setValue, deleteAdditional, dispatch]
  )

  //Function for send data from modal
  const additionalModal = data => {
    const activeButton = document.querySelector('.sendButton')
    if (activeButton.dataset.value === 'add') {
      const currentUrl = activeButton.dataset.url
      const ajaxUrl = 'manager/' + currentUrl + '/add'
      const ajaxBody = {
        name: data.additionalData.name,
        description: data.additionalData.description,
      }
      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          if (currentUrl === 'exemptions') {
            addExemptions()
          }
          if (currentUrl === 'statuses') {
            addStatuses()
          }
          if (currentUrl === 'positions') {
            addPositions()
          }
          if (currentUrl === 'employer-statuses') {
            addEmployerStatus()
          }
          if (currentUrl === 'task-types') {
            addExerciseType()
          }
          if (currentUrl === 'exemption-statuses') {
            addExemptionsStatus()
          }
          if (currentUrl === 'items') {
            addObjects()
          }
          if (currentUrl === 'placements-statuses') {
            addStatusesPlacement()
          }
          reset()
          setModalAdd(false)
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    } else {
      const currentUrl = activeButton.dataset.url
      const ajaxUrl = 'manager/' + currentUrl + '/update'
      const ajaxBody = {
        id: activeButton.dataset.id,
        name: data.additionalData.name,
        description: data.additionalData.description,
      }
      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          if (currentUrl === 'exemptions') {
            addExemptions()
          }
          if (currentUrl === 'statuses') {
            addStatuses()
          }
          if (currentUrl === 'positions') {
            addPositions()
          }
          if (currentUrl === 'employer-statuses') {
            addEmployerStatus()
          }
          if (currentUrl === 'task-types') {
            addExerciseType()
          }
          if (currentUrl === 'exemption-statuses') {
            addExemptionsStatus()
          }
          if (currentUrl === 'items') {
            addObjects()
          }
          if (currentUrl === 'placements-statuses') {
            addStatusesPlacement()
          }
          reset()
          setModalAdd(false)
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    }
  }

  const exemptionsBlock = exemptions ? (
    Object.values(exemptions).map(child => {
      return (
        <div className='item' key={child.id} onClick={event => openModal(event)} data-value='exemptions' data-id={child.id}>
          <p title={child.code}>{child.code}</p>
          <p title={child.name}>{child.name}</p>
          <p title={child.description}>{child.description}</p>
        </div>
      )
    })
  ) : (
    <Loading />
  )

  const exemptionsStatusBlock = exemptionsStatus ? (
    Object.values(exemptionsStatus).map(child => {
      return (
        <div className='item' key={child.id} onClick={event => openModal(event)} data-value='exemption-statuses' data-id={child.id}>
          <p title={child.name}>{child.name}</p>
        </div>
      )
    })
  ) : (
    <Loading />
  )

  const statusesBlock = statuses ? (
    Object.values(statuses).map(child => {
      return (
        <div className='item' key={child.id} onClick={event => openModal(event)} data-id={child.id} data-value='statuses'>
          <p title={child.code}>{child.code}</p>
          <p title={child.name}>{child.name}</p>
          <p title={child.description}>{child.description}</p>
        </div>
      )
    })
  ) : (
    <Loading />
  )

  const statusesPlacementBlock = statusesPlacement ? (
    Object.values(statusesPlacement).map(child => {
      return (
        <div className='item' key={child.id} onClick={event => openModal(event)} data-id={child.id} data-value='placements-statuses'>
          <p title={child.code}>{child.code}</p>
          <p title={child.name}>{child.name}</p>
          <p title={child.description}>{child.description}</p>
        </div>
      )
    })
  ) : (
    <Loading />
  )

  const positionsBlock = positions ? (
    Object.values(positions).map(child => {
      return (
        <div className='item' key={child.id} onClick={event => openModal(event)} data-id={child.id} data-value='positions'>
          <p title={child.code}>{child.code}</p>
          <p title={child.name}>{child.name}</p>
          <p title={child.description}>{child.description}</p>
        </div>
      )
    })
  ) : (
    <Loading />
  )

  const employerStatusBlock = employerStatus ? (
    Object.values(employerStatus).map(child => {
      return (
        <div className='item' key={child.id} onClick={event => openModal(event)} data-id={child.id} data-value='employer-statuses'>
          <p title={child.code}>{child.code}</p>
          <p title={child.name}>{child.name}</p>
        </div>
      )
    })
  ) : (
    <Loading />
  )

  const objectsBlock = objects ? (
    Object.values(objects).map(child => {
      return (
        <div className='item' key={child.id} onClick={event => openModal(event)} data-id={child.id} data-value='items'>
          <p title={child.code}>{child.code}</p>
          <p title={child.name}>{child.name}</p>
          <p title={child.description}>{child.description}</p>
        </div>
      )
    })
  ) : (
    <Loading />
  )

  const exerciseTypeBlock = exerciseType ? (
    Object.values(exerciseType).map(child => {
      return (
        <div className='item' key={child.id} onClick={event => openModal(event)} data-id={child.id} data-value='task-types'>
          <p title={child.name}>{child.name}</p>
        </div>
      )
    })
  ) : (
    <Loading />
  )

  return (
    <section className='additionalData'>
      <h1>Additional Data</h1>
      <div className='mainTable'>
        <h2>Students</h2>
        <div className='table' data-value='exemptions'>
          <div className='nameItem'>
            <h3>Exemptions</h3>
            <button data-value='exemptions' value='add' onClick={event => openModal(event)}>
              Add
            </button>
          </div>
          <div className='title'>
            <h4>Code</h4>
            <h4>Name</h4>
            <h4>Description</h4>
          </div>
          <div className='tableScroll'>{exemptionsBlock}</div>
        </div>
        <div className='table' data-value='exemption-statuses'>
          <div className='nameItem'>
            <h3>Exemptions status</h3>
            <button data-value='exemption-statuses' value='add' onClick={event => openModal(event)}>
              Add
            </button>
          </div>
          <div className='title'>
            <h4>Name</h4>
          </div>
          <div className='tableScroll'>{exemptionsStatusBlock}</div>
        </div>
        <div className='table' data-value='statuses'>
          <div className='nameItem'>
            <h3>Statuses</h3>
            <button data-value='statuses' value='add' onClick={event => openModal(event)}>
              Add
            </button>
          </div>
          <div className='title'>
            <h4>Code</h4>
            <h4>Name</h4>
            <h4>Description</h4>
          </div>
          <div className='tableScroll'>{statusesBlock}</div>
        </div>
        <div className='table' data-value='placements-statuses'>
          <div className='nameItem'>
            <h3>Status of placement</h3>
            <button data-value='placements-statuses' value='add' onClick={event => openModal(event)}>
              Add
            </button>
          </div>
          <div className='title'>
            <h4>Code</h4>
            <h4>Name</h4>
            <h4>Description</h4>
          </div>
          <div className='tableScroll'>{statusesPlacementBlock}</div>
        </div>
      </div>
      <div className='mainTable'>
        <h2>Workers</h2>
        <div className='table' data-value='positions'>
          <div className='nameItem'>
            <h3>Positions</h3>
            <button data-value='positions' value='add' onClick={event => openModal(event)}>
              Add
            </button>
          </div>
          <div className='title'>
            <h4>Code</h4>
            <h4>Name</h4>
            <h4>Description</h4>
          </div>
          <div className='tableScroll'>{positionsBlock}</div>
        </div>
        <div className='table' data-value='employer-statuses '>
          <div className='nameItem'>
            <h3>Employer status</h3>
            <button data-value='employer-statuses' value='add' onClick={event => openModal(event)}>
              Add
            </button>
          </div>
          <div className='title'>
            <h4>Code</h4>
            <h4>Name</h4>
          </div>
          <div className='tableScroll'>{employerStatusBlock}</div>
        </div>
      </div>
      <div className='mainTable'>
        <h2>Payments</h2>
        <div className='table' data-value='items'>
          <div className='nameItem'>
            <h3>Objects</h3>
            <button data-value='items' value='add' onClick={event => openModal(event)}>
              Add
            </button>
          </div>
          <div className='title'>
            <h4>Code</h4>
            <h4>Name</h4>
            <h4>Description</h4>
          </div>
          <div className='tableScroll'>{objectsBlock}</div>
        </div>
      </div>
      <div className='mainTable'>
        <h2>Courses</h2>
        <div className='table' data-value='task-types'>
          <div className='nameItem'>
            <h3>Exercise type</h3>
            <button data-value='task-types' value='add' onClick={event => openModal(event)}>
              Add
            </button>
          </div>
          <div className='title'>
            <h4>Name</h4>
          </div>
          <div className='tableScroll'>{exerciseTypeBlock}</div>
        </div>
      </div>
      <Modal active={modalAdd} setActive={setModalAdd}>
        <h2>{modalTitle}</h2>
        <form onSubmit={handleSubmit(additionalModal)} autoComplete='off'>
          <label>
            <p>
              Name <span className='requiredInput'>*</span>
            </p>
            <input
              {...register('additionalData.name', {
                required: 'This field is required',
                minLength: {
                  value: 3,
                  message: 'Min length 3',
                },
                maxLength: {
                  value: 50,
                  message: 'Max length 50',
                },
              })}
            />
          </label>
          <span className='errorResponse'>
            {errors.hasOwnProperty('additionalData') && errors.additionalData.hasOwnProperty('name') ? errors.additionalData.name.message : null}
          </span>
          <label className={descriptionModal ? 'block' : 'none'}>
            Description
            <textarea
              {...register('additionalData.description', {
                maxLength: {
                  value: 50,
                  message: 'Max length 50',
                },
              })}
            />
          </label>
          <span className='errorResponse'>
            {errors.hasOwnProperty('additionalData') && errors.additionalData.hasOwnProperty('description')
              ? errors.additionalData.description.message
              : null}
          </span>
          <div className='buttons'>
            <input type='submit' className='sendButton' value='Save' disabled={!isValid} />
            {modalButton}
          </div>
        </form>
      </Modal>
    </section>
  )
}
